import React from 'react'

function Loading() {
  return (
    <div data-testid="loadingSpinner" className="loading">
      <div className="lds-rolling">
        <div />
      </div>
    </div>
  )
}

export default Loading
